// src/pages/admin/dashboard/components/DashboardKpiCards.js
import React from "react";
import { Row, Col, Card, Badge } from "react-bootstrap";

const DashboardKpiCards = ({ statCards }) => {
  return (
    <Row className="g-4 mb-4">
      {statCards.map((card, index) => (
        <Col
          xs={12}
          sm={6}
          lg={3}
          key={index}
        >
          <Card className="dashboard-stat-card h-100">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="dashboard-icon">
                  {card.icon}
                </div>

                <div className="ms-3">
                  <p className="dashboard-card-title">
                    {card.title}
                  </p>

                  <h3 className="dashboard-card-value">
                    {card.value}
                  </h3>
                </div>
              </div>

              <Badge bg="danger">
                {card.growth}
              </Badge>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardKpiCards;
